export default [
    {
        path: '/validate-gdpr',
        name: 'ValidateGDPR',
        component: () =>
            import(
                /* webpackChunkName: "ValidateGDPR" */ '@/views/FirstLogin/ValidateGDPR/index.vue'
            )
    },
    {
        path: '/sign-documents',
        name: 'SignDocuments',
        component: () =>
            import(
                /* webpackChunkName: "SignDocuments" */ '@/views/FirstLogin/SignDocuments/index.vue'
            )
    },
    {
        path: '/update-minor',
        name: 'UpdateMinor',
        component: () =>
            import(/* webpackChunkName: "UpdateMinor" */ '@/views/FirstLogin/UpdateMinor/index.vue')
    },
    {
        path: '/crs-fatca-renewal',
        name: 'CRSFATCARenewal',
        component: () =>
            import(
                /* webpackChunkName: "CRSFATCARenewal" */ '@/views/FirstLogin/CRSFATCARenewal/index.vue'
            )
    },
    {
        path: '/update-two-factor-auth',
        name: 'UpdateTwoFactorAuth',
        component: () =>
            import(
                /* webpackChunkName: "UpdateTwoFactorAuth" */ '@/views/FirstLogin/UpdateTwoFactorAuth/index.vue'
            )
    },
    {
        path: '/anual-report-notifications',
        name: 'AnnualReportNotifications',
        component: () =>
            import(
                /* webpackChunkName: "AnnualReportNotifications" */ '@/views/FirstLogin/AnnualReportNotifications/index.vue'
            )
    }
];
